<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousFFView"
            >&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="25"></md-layout>
          <md-layout md-flex="40">
            <h2>Documentation NOC</h2>
          </md-layout>
        </md-layout>

        <hr class="hr-s" />
        <div class id="vehicleBooking">
          <md-list>
            <md-list-item
              id="showVisibility"
              class="md-button-color-toggle md-active"
              @click="showOverflow"
              style
            >
              <span>Documentation - Noc</span>

              <md-list-expand>
                <md-list>
                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="70"></md-layout>

                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>Current Date & Time</label>
                        <b-form-input :formatter="capitalizeAll" disabled v-model="NocModel.currentDate"></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>Importer Name</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="importerName"
                          name="importerName"
                          v-model="NocModel.importerName"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="20">
                      <label>House B/L Receiving Date</label>
                      <date-picker
                        lang="en"
                        name="weighingDate"
                        id="weighingDate"
                        type="datetime"
                        format="YYYY-MM-DD hh:mm a"
                        v-model="NocModel.receivingDate"
                      ></date-picker>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="15">
                      <md-layout md-flex="100">
                        <label>Enter MBL No</label>
                        <b-form-input :formatter="capitalizeAll" id="mblNo" name="mblNo" v-model="NocModel.mblNo"></b-form-input>
                      </md-layout>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="15">
                      <md-layout md-flex="100">
                        <label>Enter HBL No</label>
                        <b-form-input :formatter="capitalizeAll" id="hblNo" name="hblNo" v-model="NocModel.hblNo"></b-form-input>
                      </md-layout>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>
                  </md-layout>
                  <md-layout
                    md-gutter
                    class="labelMargtop"
                    v-if="NormalseaImportDataModel.containerInfo=='lcl'"
                  >
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>Co-Loader Name</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="coLoaderName"
                          name="coLoaderName"
                          v-model="NocModel.coLoaderName"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <md-layout
                    md-gutter
                    class="labelMargtop"
                    v-if="NormalseaImportDataModel.containerInfo=='lcl'"
                  >
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="90">
                      <label>Co-Loader Address</label>
                      <b-form-textarea :formatter="capitalizeAll"
                        id="coloaderAdd"
                        name="coloaderAdd"
                        v-model="NocModel.coloaderAdd"
                      ></b-form-textarea>
                    </md-layout>
                  </md-layout>
                  <hr class="hr-border" />
                  <div class="box">
                    <div class="box-header">
                      <h3 class="box-title">
                        <u>Container Detail</u>
                      </h3>
                    </div>
                    <!-- /.box-header -->
                    <div class="box-body">
                      <table id="FreghtContaner" class="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>Container No</th>
                            <th>Seal No</th>

                            <th>Package Detail</th>
                            <th>Gross Weight</th>
                            <th>Measurement(CBM)</th>
                            <!-- <th v-if="ExecutionDisable==''">Delete</th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item1,index) in getContainerList" :key="index">
                            <td>
                              {{item1.containerNo}}
                              <br />
                              {{item1.containerType}}
                            </td>

                            <td>{{item1.lineSealNo}}</td>
                            <td>{{item1.noOfPkg}} {{item1.packageName}}</td>
                            <td>{{item1.grossWeight}}</td>
                            <td>{{item1.measurement}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- /.box-body -->
                    <hr class="hr-border" />
                  </div>
                  <!-- <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="30">
                      <label>Container No./ Seal No.</label>
                      <quill-editor ref="containerSealNo" v-model="NocModel.containerSealNo"></quill-editor>
                    </md-layout>
                  </md-layout>-->
                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="90">
                      <md-layout md-flex="100">
                        <label>Preparation of NOC for Shipping Line</label>
                      </md-layout>
                      <md-layout md-flex="100">
                        <quill-editor
                          style="width:100% !important;height:500px !important"
                          v-model="NocModel.nocPreparation"
                        ></quill-editor>
                      </md-layout>
                    </md-layout>
                  </md-layout>

                  <hr class="hr-border" />

                  <md-layout md-gutter>
                    <md-layout md-flex="40"></md-layout>

                    <md-layout md-flex="20">
                      <md-button
                        class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                        @click="addNocDocumentation"
                        id="addButtonLoaderNoc"
                      >Save</md-button>

                      <md-spinner md-indeterminate id="loaderNoc" style="display:none"></md-spinner>
                    </md-layout>

                    <md-layout md-flex="15"></md-layout>
                    <md-layout md-flex="20" v-if="NocModel.ffNocId!=''">
                      <md-button
                        class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                        @click="Print('NocDoc',NocModel.uploadNocDoc)"
                        id="addButtonLoaderAuth"
                      >Print</md-button>
                    </md-layout>
                  </md-layout>
                </md-list>
              </md-list-expand>
            </md-list-item>
          </md-list>
        </div>

        <!-- <hr class="hr-s">
        <div>
          <md-list>
            <md-list-item id="showvehicleBooking" class="md-button-color-toggle md-active">
              <span>Documentation ­ Authorization Letter</span>

              <md-list-expand>
                <md-list>
                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30">
                      <md-layout md-flex="100">
                        <label>Importer Name</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="importerName"
                          name="importerName"
                          v-model="AuthModel.importerName"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="20">
                      <md-layout md-flex="100">
                        <label>MBL NO</label>
                        <b-form-input :formatter="capitalizeAll" id="mblNo1" name="mblNo1" v-model="AuthModel.mblNo"></b-form-input>
                      </md-layout>
                    </md-layout>

                    <md-layout md-flex="10"></md-layout>

                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>Current Date & Time</label>
                        <b-form-input :formatter="capitalizeAll" disabled v-model="AuthModel.currentDate"></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="30">
                      <label>Container No./ Seal No.</label>
                      <quill-editor ref="containerSealNo" v-model="AuthModel.containerSealNo"></quill-editor>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="90">
                      <md-layout md-flex="100">
                        <label>Authorization Letter</label>
                      </md-layout>
                      <md-layout md-flex="100">
                        <quill-editor
                          style="width:100% !important;height:450px !important"
                          v-model="AuthModel.authLetter"
                        ></quill-editor>
                      </md-layout>
                    </md-layout>
                  </md-layout>

                  <hr class="hr-border">

                  <md-layout md-gutter>
                    <md-layout md-flex="40"></md-layout>

                    <md-layout md-flex="20">
                      <md-button
                        class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                        @click="addAuthDocumentation"
                        id="addButtonLoaderAuth"
                      >Submit Auth</md-button>

                      <md-spinner md-indeterminate id="loaderAuth" style="display:none"></md-spinner>
                    </md-layout>
                    <md-layout md-flex="15"></md-layout>

                    <md-layout md-flex="20" v-if="AuthModel.ffAuthId!=''">
                      <md-button
                        class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                        @click="Print('AuthDoc',AuthModel.uploadAuthDoc)"
                        id="addButtonLoaderAuth"
                      >Print</md-button>
                    </md-layout>
                  </md-layout>
                </md-list>
              </md-list-expand>
            </md-list-item>
          </md-list>
        </div>-->
      </md-card-content>
    </md-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22"
      @close="onClose22"
    ></md-dialog-alert>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopData"
      @close="ProceedSail"
    ></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Sea Freight") &&
      this.$sessionsStorage.get("editffSeaImportId") != "" &&
      this.$sessionsStorage.get("editffSeaImportId") != undefined
    ) {
      this.$store.dispatch("setCurrentRoute", "/seaImport/documentation");

      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  watch: {},
  data() {
    return {
      isLoading: false,
      docURL: URL_BASE_DOC,
      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      NocModel: {
        ffNocId: "",
        ffImportId: this.$sessionsStorage.get("editffSeaImportId"),
        receivingDate: "",
        nocPreparation: "",
        currentDate: "",
        mblNo: "",
        hblNo: "",
        importerName: "",
        containerSealNo: "",
        coLoaderName: "",
        coloaderAdd: "",
        uploadNocDoc: "",
        containerInfo: ""
      },
      AuthModel: {
        ffAuthId: "",
        ffImportId: this.$sessionsStorage.get("editffSeaImportId"),
        importerName: "",
        mblNo: "",
        currentDate: "",
        containerSealNo: "",
        authLetter: "",
        uploadAuthDoc: "",
        containerInfo: ""
      },
      NormalseaImportDataModel: {},

      railOutTableArray: [],
      getContainerList: [],
      deleteId: "",
      showVisible: false,

      validate: true,
      validateRail: true,
      toMain: "",
      toMainAuth: ""
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    quillEditor
  },
  computed: {},
  methods: {
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    routePage() {
      this.$router.push({
        path: "/ffExportCon/consoFclSailFpod"
      });
    },

    Print(dir, value) {
      window.open(`${this.docURL}/SeaImport/` + dir + "/" + value);
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "ff_railouttable",
          tableId: "railOutTableId",
          isActive: "isRailTableActive",
          tableVal: this.deleteId
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            this.getData();
            this.deleteId = "";
          })
          .catch(error => {});
      }
    },

    JqueryFun() {
      //   return $(function() {
      //     return $("#railOuttariff").DataTable();
      //   });
    },

    ProceedSail() {},

    validateFFExport() {
      let validate_new = true;

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    showOverflow() {},

    addNocDocumentation() {
      this.NocModel["containerDetail"] = this.getContainerList;
      if (this.validate != false) {
        $("#addButtonLoaderNoc").css("display", "none");
        $("#loaderNoc").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaImport/addNocDoc.php`,
          data: JSON.stringify(this.NocModel),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            //  console.log(result);
            if ( status == 200 && data) {
              $("#loaderNoc").css("display", "none");
              $("#addButtonLoaderNoc").css("display", "block");
              if (this.NocModel.ffNocId == "") {
                this.alert.content = "Data Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
              }
              this.NocModel.ffNocId = data.ffNocId;
              this.$refs["addPop"].open();
              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    addAuthDocumentation() {
      if (this.validate != false) {
        $("#addButtonLoaderAuth").css("display", "none");
        $("#loaderAuth").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaImport/addAuthDoc.php`,
          data: JSON.stringify(this.AuthModel),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            //  console.log(result);
            if ( status == 200 && data) {
              $("#loaderAuth").css("display", "none");
              $("#addButtonLoaderAuth").css("display", "block");

              if (this.AuthModel.ffAuthId == "") {
                this.alert.content = "Data Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
              }
              this.AuthModel.ffAuthId = data.ffAuthId;
              this.$refs["addPop"].open();
              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    onClose22() {},

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        minute = d.getMinutes(),
        Hour = d.getHours(),
        second = d.getSeconds();

      if (month.length < 2) month = "0" + month;

      if (day.length < 2) day = "0" + day;

      let dateNew = [year, month, day].join("-");

      let minuteNew = [Hour, minute].join(":");

      return dateNew + " " + minuteNew;
    },
    getData() {
      let vehicle_drive = {
        ffImportId: this.$sessionsStorage.get("editffSeaImportId")
      };
      this.doLoading();

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaImport/fetchDocumentation.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log(data);

            Object.keys(data.NormalseaImportData[0]).map(x => {
              this.NormalseaImportDataModel[x] =
                data.NormalseaImportData[0][x] || "";
            });

            if (data.NocDocumentArray.length > 0) {
              Object.keys(this.NocModel).map(x => {
                this.NocModel[x] = data.NocDocumentArray[0][x] || "";
              });
            } else {
              this.NocModel.containerInfo =
                data.NormalseaImportData[0].containerInfo;
              if (data.NormalseaImportData[0].containerInfo == "fcl") {
                this.toMain = "<p>HAPAG Lloyd India Pvt. Ltd</p>";
                this.NocModel.mblNo = data.NormalseaImportData[0].firstBLNumber;
                this.NocModel.hblNo =
                  data.NormalseaImportData[0].secondBLNumber;
              } else {
                this.toMain =
                  "<p><<--From Input Coloader Name->></p><p><<--From Input Coloader Address->></p>";
                this.NocModel.mblNo =
                  data.NormalseaImportData[0].lclmasterBLNumber;
                this.NocModel.hblNo =
                  data.NormalseaImportData[0].secondBLNumber;
              }
              this.NocModel.currentDate = this.formatDate(new Date());

              if (data.LastPreparationNoc.length > 0) {
                this.NocModel.nocPreparation =
                  data.LastPreparationNoc[0].nocPreparation;
              } else {
                this.NocModel.nocPreparation =
                  "<p>To,</p><p>Import Manager,</p>" +
                  this.toMain +
                  "<br/><p>Subject: - NOC For Delivery Order issuing to the name of Actual Consignee  <b> <<--From Input Importer->></b></p><p>Ref :  M-B/L Nos: <b><<--From Input MBL->></b> & H-B/L Nos:  <b><<--From Input HBL->> </b></p><p><<--Container_Details_Table->></p><p>Respected  Sir,</p></br><p>With reference to the subject, We are pleased to informed you that we have doing the above said Import shipment on your good carrier with our H-B/L Involved, We kindly request you to Please release the Delivery Order against said Import shipment to the actual consignee namely are : <b> <<--From Input Importer->></b> .By doing this we have no objection against this request, So you’re requested to release the delivery order as per above request.</p></br><p>We will highly appreciated for your kind approval and your kind support,</p></br><p>We shall be thankful for your co-operation.</p><br/><b><p>Thanking You,</p><p>For: PRIDEL Pvt. Ltd.</p><p>Authorized Signatory</p>";
              }

              this.NocModel.importerName =
                data.NormalseaImportData[0].importerName;
              this.NocModel.containerSealNo =
                data.NormalseaImportData[0].containerSealNo;
              this.NocModel.coLoaderName =
                data.NormalseaImportData[0].coLoaderNameNew;
              this.NocModel.coloaderAdd = data.NormalseaImportData[0].address;
            }

            if (data.AuthDocumentArray.length > 0) {
              Object.keys(this.AuthModel).map(x => {
                this.AuthModel[x] = data.AuthDocumentArray[0][x] || "";
              });
            } else {
              this.AuthModel.containerInfo =
                data.NormalseaImportData[0].containerInfo;
              if (data.NormalseaImportData[0].containerInfo == "fcl") {
                this.toMainAuth =
                  "<p><b>ONE ( Ocean Network Express) Line (India ) Pvt. Ltd.</b></p>";
                this.AuthModel.mblNo =
                  data.NormalseaImportData[0].firstBLNumber;
              } else {
                this.toMainAuth = "";
                this.AuthModel.mblNo =
                  data.NormalseaImportData[0].lclmasterBLNumber;
              }
              this.AuthModel.currentDate = this.formatDate(new Date());

              if (data.LastAuthLetter.length > 0) {
                this.AuthModel.nocPreparation =
                  data.LastAuthLetter[0].nocPreparation;
              } else {
                this.AuthModel.authLetter =
                  "<br/><br/>" +
                  this.toMainAuth +
                  "<p>New Delhi.</p><p>Dear Sir/Madam,</p><br/><p>Sub: Delivery Order Against MBL NO.<b><<--From Input MBL->></b> </p><p>Container No.</p><p><<--From Input Container->></p><br/><p>Ref to above shipment we hereby authorize to Mr <b><<--From Input Importer->></b> the bearer of this letter specimen signature is attested below to collect the DO and all other relevant documents against above.<p><br/><p>Therefore, you are requested to please handover the Delivery Order and all other relevant documents to him and oblige.<p><p>Specimen Signature Attested.<p><br/><b><p>Thanking You,<p><br/><p>Yours Faithfully,<p><p>For PRIDEL Pvt. Ltd.</p></b>";
              }

              this.AuthModel.importerName =
                data.NormalseaImportData[0].importerName;
              this.AuthModel.containerSealNo =
                data.NormalseaImportData[0].containerSealNo;
            }
            if (data.multiContainerData.length > 0) {
              this.getContainerList = data.multiContainerData;
            }

            this.JqueryFun();
            this.doLoadingClose();
          }
        })
        .catch(error => {});
    },

    deleteData(item) {
      this.deleteId = item.railOutTableId;

      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },

    previousFFView() {
      this.$router.push({
        path: "/seaImport/ffSeaImportExecution"
      });
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// ImportNOCDocNormal.vue?7ba61c64